<template>
    <MicroAppProPage />
</template>

<script setup lang="ts">
import MicroAppProPage from '~/components/micro-app/MicroAppProListPage.vue'
</script>
